export const Palette = {
  "700": 700,
  "50": 50,
};
